import React, {Component} from "react";
import {connect} from "react-redux";
import CreateQuestionActivity from "../new/create-question-activity";

class EditQuestionActivity extends Component {

    constructor(props) {
        super(props);
        
    }

    render() {
        const { params } = this.props; // react-router v3 injects params here
        return <CreateQuestionActivity key={params.id} {...this.props} />;
    }

}


function mapStateToProps(state) {
    return {...state};
}
export default connect(mapStateToProps)(EditQuestionActivity);

